import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import LazyLoad from "react-lazy-load";
import { connect } from "react-redux";
var LockedChannel = function(param) {
    var i18n = param.i18n;
    var locked_channel = i18n.common.lockedChannel.split(" ");
    return /*#__PURE__*/ _jsx(LazyLoad, {
        offset: 1000,
        debounce: false,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("img", {
                    draggable: "false",
                    style: {
                        width: "100%",
                        height: "auto"
                    },
                    src: "/common/assets/media/locked_channel.png"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    style: {
                        position: "absolute",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "4rem",
                        color: "white",
                        flexDirection: "row",
                        padding: 16,
                        textTransform: "uppercase",
                        width: "100%",
                        height: "100%",
                        top: 0
                    },
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon-settings-font-lock"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "locked-channel-text",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: locked_channel[0]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        fontWeight: "300"
                                    },
                                    children: locked_channel[1]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default connect(mapStateToProps)(LockedChannel);
